import { ArrowRightOutlined, FileImageOutlined } from "@ant-design/icons";
import { Card, Flex, Tag, Typography } from "antd";
const { Text } = Typography;
export default function ProductCard({ product, onClick }) {
  const providers = product.providers || [];
  return (
    <Card
      hoverable
      className="specstudio-card"
      onClick={onClick}
      cover={
        <div className="specstudio-card-image">
          {product.thumbnail ? (
            <img src={product.thumbnail} alt={product.name} />
          ) : (
            <Text type="secondary">
              <FileImageOutlined /> Chưa có ảnh
            </Text>
          )}
        </div>
      }
      styles={{ body: { padding: 16 } }}
    >
      <Flex justify="space-between" align="center" gap={8}>
        <Text type="secondary" ellipsis className="specstudio-card-category">
          {product.category?.name || "Chưa phân loại"}
        </Text>
        <Tag color="blue" className="specstudio-sku" bordered={false}>
          {product.productCode}
        </Tag>
      </Flex>
      <Text strong ellipsis className="specstudio-card-name">
        {product.name}
      </Text>
      <Flex
        justify="space-between"
        align="center"
        gap={8}
        className="specstudio-card-footer"
      >
        <Text type="secondary" ellipsis>
          {providers.length
            ? providers.map((p) => p.factoryName).join(", ")
            : "Chưa có nhà in"}
        </Text>
        <ArrowRightOutlined className="specstudio-card-arrow" />
      </Flex>
    </Card>
  );
}
